<app-singleselectbox 
    caption="Location" 
    name="Id" 
    valueExpr="Id" 
    displayExpr="Name"
    required 
    [value]="$safeNavigationMigration(selectedtransportConfiguration()?.Id)"
    [dataSource]="dropDownDataSource()"
    [itemTemplate]="itemTemplate"
    [grouped]="true"
    [searchExpr]="searchExprOption()"
    [disabled]="disabled()"
    (valueChange)="onValueChange($event)">
    <ng-template #itemTemplate let-data>
        <div class="item-template">
            <div class="item-template-grid-items">
                <span>{{data.Name}}</span>
            </div>
            <div class="item-template-grid-items">
                <span>Transport Type:</span>
                <span>{{data.TransportTypeName}}</span>
            </div>
            <div class="item-template-grid-items">
                <span>Address:</span>
                <span>{{data.DisplayAddress}}</span>
            </div>
        </div>
    </ng-template>
</app-singleselectbox>
